import { RefreshCw, X } from 'lucide-react';

interface UpdateBannerProps {
  latestVersion: string;
  onRefresh: () => void;
  onDismiss: () => void;
}

export function UpdateBanner({ latestVersion, onRefresh, onDismiss }: UpdateBannerProps) {
  return (
    <div className="bg-plum/10 border-b border-plum/20 px-4 py-2.5 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0">
        <RefreshCw size={14} className="text-plum shrink-0" />
        <p className="text-[13px] text-midnight truncate">
          A new version{latestVersion ? ` (v${latestVersion})` : ''} is available.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          type="button"
          onClick={onRefresh}
          className="h-8 px-3 rounded-lg bg-plum text-white text-[12px] font-semibold
                     hover:bg-rose transition-colors"
        >
          Refresh Now
        </button>
        <button
          type="button"
          onClick={onDismiss}
          className="h-8 w-8 rounded-lg text-slate hover:text-midnight flex items-center justify-center
                     transition-colors"
          aria-label="Dismiss"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
